import AppHeader from '../../components/app-header';
import TextInput from '../../components/TextInput';
import './index.css';
import { FormEvent, MouseEvent, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { StudentData } from 'types/snackpack-student-data';
import { GetSnackpackStudentData } from 'api/snackpack-student-endpoint';
import SnackpackStudentData from 'components/snackpack/SnackpackStudentData';

function MainPage(): JSX.Element {
  const [student, setStudent] = useState<StudentData>();
  const [searchString, setSearchString] = useState('');
  const [loading, setLoading] = useState(false);
  const [readyForSubmission, setReadyForSubmission] = useState(false);
  const [studentIdInputValidationMessage, setStudentIdInputValidationMessage] = useState('');
  const [queryResultMessage, setQueryResultMessage] = useState('');

  useEffect(() => {
    setStudentIdInputValidationMessage('');
    setReadyForSubmission(false);
    setQueryResultMessage('');

    // setTimeout so that we only validate if user stops typing
    const timeoutId = setTimeout(() => {
      validateSearchStringAsStateStudentId();
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchString]);

  function validateSearchStringAsStateStudentId() {
    let validationMessage = '';
    let readyForSubmission = true;
    if (!/^\d{10}$/.test(searchString)) {
      validationMessage = 'State Student Id must be 10 digits (0-9).';
      readyForSubmission = false;
    }
    if (searchString.length !== 10) {
      validationMessage += ` Current length is ${searchString.length}`;
      readyForSubmission = false;
    }
    if (searchString === '') {
      validationMessage = 'Look up data for a given State Student Id';
    }

    setStudentIdInputValidationMessage(validationMessage);
    setReadyForSubmission(readyForSubmission);
  }

  async function lookupStudent(e: FormEvent<HTMLFormElement> | MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    if (readyForSubmission) {
      setLoading(true);
      setStudent(undefined);
      try {
        const result = await GetSnackpackStudentData(searchString);
        if (result.success) {
          setStudent(result.data);
          setQueryResultMessage('');
        } else {
          setQueryResultMessage(result.message || 'Failed to retrieve student.');
        }
      } catch (error) {
        setQueryResultMessage('Failed to make call to retrieve student.');
      } finally {
        setLoading(false);
        setReadyForSubmission(false);
      }
    }
  }

  return (
    <div className='snackpack-main_root'>
      <AppHeader />
      <div className='snackpack-main_content'>
        <form onSubmit={lookupStudent} className='snackpack-search'>
          <TextInput name='searchString' label='State Student Id' value={searchString} inputLabelProps={{ shrink: true }} onChange={(e) => setSearchString(e.target.value)} />
          <Button variant='contained' color='primary' onClick={lookupStudent} disabled={!readyForSubmission}>
            Look up Student Data
          </Button>
        </form>
        {studentIdInputValidationMessage && <div>{studentIdInputValidationMessage}</div>}
        {loading && <div>Loading Student Data...</div>}
        {queryResultMessage && <div style={{ color: '#f44336' }}>{queryResultMessage}</div>}
        {!student || !student.StateStudentId || student.StateStudentId === '' ? <h2>No Student Selected</h2> : <SnackpackStudentData student={student} />}
      </div>
    </div>
  );
}

export default MainPage;
